import { createTheme } from '@mui/material/styles';

// Paleta de la marca: tinta profunda + coral, sobre un fondo cálido
export const brand = {
  ink: '#1D1B3A',
  inkLight: '#3A3766',
  inkDark: '#110F24',
  coral: '#FF6B3D',
  coralDark: '#E0522A',
  cream: '#FFF6EE',
  sand: '#F6F4F0',
};

// A custom theme for this app
const baseTheme = createTheme({
  palette: {
    primary: {
      main: brand.ink,
      light: brand.inkLight,
      dark: brand.inkDark,
      contrastText: '#ffffff',
    },
    secondary: {
      main: brand.coral,
      dark: brand.coralDark,
      contrastText: brand.ink,
    },
    background: {
      default: brand.sand,
      paper: '#ffffff',
    },
    text: {
      primary: brand.ink,
      secondary: '#6B6880',
    },
    divider: '#E6E3DD',
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    h4: { fontWeight: 800, letterSpacing: '-0.02em' },
    h5: { fontWeight: 800, letterSpacing: '-0.01em' },
    h6: { fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: {
    borderRadius: 8,
  },
});

// Ajustes globales de componentes para que todas las secciones compartan el mismo estilo
const theme = createTheme(baseTheme, {
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 10, paddingInline: 18 },
        sizeLarge: { paddingBlock: 12, fontSize: 16 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: `1px solid ${baseTheme.palette.divider}`,
          boxShadow: 'none',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600, borderRadius: 8 },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 16 },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: { fontWeight: 800 },
      },
    },
  },
});

export default theme;
